import { queryOptions } from '@tanstack/react-query'
import { fetchMe } from '@/shared/api'
import type { Session } from '../model/schema'

export const sessionQueryKey = ['session'] as const

export const sessionQueryOptions = queryOptions({
  queryKey: sessionQueryKey,
  queryFn: (): Promise<Session | null> => fetchMe(),
  staleTime: 60_000,
})
